import a from "./index293.js";
import { createElementBlock as s, openBlock as i, createElementVNode as n, createVNode as d, renderSlot as r, Transition as p, withCtx as u, createCommentVNode as m, normalizeClass as l } from "vue";
/* empty css         */
import f from "./index231.js";
const v = ["data-component"];
function M(o, e, g, C, $, k) {
  return i(), s("div", {
    "data-component": o.$options.name,
    class: "cs-tooltip"
  }, [
    n("div", {
      "data-test-id": "trigger",
      onClick: e[0] || (e[0] = (...t) => o.onClick && o.onClick(...t)),
      onMouseenter: e[1] || (e[1] = (...t) => o.onMouseEnter && o.onMouseEnter(...t)),
      onMouseleave: e[2] || (e[2] = (...t) => o.onMouseLeave && o.onMouseLeave(...t))
    }, [
      r(o.$slots, "trigger", {}, void 0, !0)
    ], 32),
    d(p, {
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: u(() => [
        o.isVisible ? (i(), s("div", {
          key: 0,
          class: l(["cs-tooltip__tooltip", {
            "-top": o.isTop,
            "-bottom": o.isBottom,
            "-left": o.isLeft,
            "-right": o.isRight
          }]),
          "data-test-id": "tooltip",
          onMouseenter: e[3] || (e[3] = (...t) => o.onMouseEnterTooltip && o.onMouseEnterTooltip(...t)),
          onMouseleave: e[4] || (e[4] = (...t) => o.onMouseLeave && o.onMouseLeave(...t))
        }, [
          r(o.$slots, "default", {}, void 0, !0),
          n("div", {
            class: l(["cs-tooltip__nudge", {
              "-top": o.isTop,
              "-bottom": o.isBottom,
              "-left": o.isLeft,
              "-right": o.isRight
            }]),
            "data-test-id": "nudge"
          }, null, 2)
        ], 34)) : m("", !0)
      ]),
      _: 3
    })
  ], 8, v);
}
const y = /* @__PURE__ */ f(a, [["render", M], ["__scopeId", "data-v-3bd96b12"]]);
export {
  y as default
};
